import { Box, Drawer, Typography } from '@mui/material';
import React from 'react';
import PeriversLogoWhite from '../../../../assets/svg/perivers-logo-white.svg';
import { useAuthContext } from '../../../auth';
import { MobileNavigationDialog } from '../mobile-dialog/mobile-navigation-dialog';
import { BottomNavigationItems, Navigation } from '../navigation/navigation';
import { UserProfileDropdown } from '../user-profile/user-profile-dropdown';
import {
  bottomSectionSx,
  bottomBrandSx,
  bottomDividerSx,
  collapsedLogoSx,
  drawerContentSx,
  drawerPaperSx,
  headerContainerSx,
  navSectionSx,
} from './styles';

interface PeriverseSidebarProps {
  mobileMenuOpen?: boolean;
  onMobileMenuClose?: () => void;
}

export const PeriverseSidebar: React.FC<PeriverseSidebarProps> = ({
  mobileMenuOpen = false,
  onMobileMenuClose,
}) => {
  const { user } = useAuthContext();

  if (!user) return null;

  const isCollapsed = true;

  const drawerContent = (
    <Box sx={drawerContentSx(isCollapsed)}>
      <Box sx={headerContainerSx}>
        <Box sx={collapsedLogoSx}>
          <img
            src={PeriversLogoWhite}
            alt="Perivers"
            style={{ width: 32, height: 32 }}
          />
        </Box>
      </Box>

      <Box sx={navSectionSx}>
        <Navigation isCollapsed={isCollapsed} />
        <BottomNavigationItems isCollapsed={isCollapsed} />
      </Box>

      <Box sx={bottomSectionSx(isCollapsed)}>
        <Box
          sx={{
            width: '100%',
            height: '40px',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <UserProfileDropdown
            isCompact={isCollapsed}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          />
        </Box>
        <Box sx={bottomDividerSx} />
        <Typography sx={bottomBrandSx}>PeritasAI</Typography>
      </Box>
    </Box>
  );

  return (
    <>
      <Drawer
        variant="persistent"
        anchor="left"
        open={true}
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': drawerPaperSx(isCollapsed),
        }}
      >
        {drawerContent}
      </Drawer>

      <MobileNavigationDialog
        open={mobileMenuOpen}
        onClose={onMobileMenuClose ?? (() => undefined)}
      />
    </>
  );
};
